import { checkSession } from "@features/auth";
import TypesafeI18n from "@i18n/i18n-react";
import type { Locales } from "@i18n/i18n-types";
import { detectLocale, isLocale } from "@i18n/i18n-util";
import { loadLocaleAsync, loadNamespaceAsync } from "@i18n/i18n-util.async";
import { Outlet, createRootRouteWithContext } from "@tanstack/react-router";
import { navigatorDetector } from "typesafe-i18n/detectors";
import { HubSessionProvider } from "@contexts/HubSessionContext";
import { AppRouterContext } from "~/router";

// Get locale: use localStorage if present, otherwise detect from browser
const getLocale = (): Locales => {
	const storedLocale = localStorage.getItem("locale");
	if (storedLocale && isLocale(storedLocale)) {
		return storedLocale as Locales;
	}
	// No localStorage value, detect from browser
	return detectLocale(navigatorDetector);
};

const locale = getLocale();
console.log("Detected locale:", locale, "localStorage:", localStorage.getItem("locale"));

export const Route = createRootRouteWithContext<AppRouterContext>()({
	component: RootComponent,
	async beforeLoad(ctx) {
		await Promise.all([
			checkSession(),
			loadLocaleAsync(locale),
			loadNamespaceAsync(locale, "auth"),
			loadNamespaceAsync(locale, "consumer-app"),
			loadNamespaceAsync(locale, "new-ui"),
			loadNamespaceAsync(locale, "shared"),
		]);
	},
});

function RootComponent() {
	return (
		<TypesafeI18n locale={locale}>
			<HubSessionProvider>
				<div className="bg-slate-50">
					<div className="min-h-svh bg-slate-50" data-vaul-drawer-wrapper="">
						<Outlet />
					</div>
				</div>
			</HubSessionProvider>
		</TypesafeI18n>
	);
}
